module.exports = __webpack_public_path__ + "static/media/flask.a38b0df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/flask.png
// module id = 1493
// module chunks = 0